export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones de calidad"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a lista de contenedores"])}
        }
      },
      "en": {
        "labels": {
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality inspections"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to container list"])}
        }
      }
    }
  })
}